<template>
  <div>
    <div class="wrapper chart-css" v-if="!showImage">
      <div class="bar">
        <template v-for="i in ops.length + 1">
          <div class="box" :key="i" :style="{width: `${unitWidth}px`}"></div>
        </template>
        <div v-if="marker" style="position: relative;">
          <div v-if="marker2 > 0" class="v-circle" :style="{ top: `-8px`, left: `${widthPixels(marker2)-4}px`}"></div>
          <div class="v-square" :style="{ top: `-5px`, left: `${widthPixels(marker)}px`}"></div>
          <div class="v-diamond" :style="{ top: `-2px`, left: `${widthPixels(value) + 4}px`}"></div>
        </div>
      </div>
    </div>
    <img :src="dataurl" v-if="showImage" class="ho-bar-chart" />
  </div>
</template>


<script>
import html2canvas from "html2canvas";
export default {
  props: {
    value: {
      required: true,
      validator: typeof value == "number"
    },
    ops: {
      required: true
    },
    marker: {
      default: 0,
      validator: typeof value == "number"
    },
    marker2: {
      default: -1,
      validator: typeof value == "number"
    },
    width: {
      type: Number,
      default: 10
    },
    forPrint: {
      default: false
    }
  },
  data() {
    return {
      dataurl: "",
      showImage: false
    };
  },
  mounted() {
    if (this.forPrint) {
      this.getDataUrl(this.$el.getElementsByClassName("chart-css")[0]);
    }
  },
  computed: {
    unitWidth() {
      return Math.round(100 / (this.ops.length + 1));
    }
  },
  methods: {
    widthPixels(value) {
      return (
        Math.round(this.unitWidth * value) -
        this.unitWidth * (this.ops.length + 1) -
        5
      );
    },
    async getDataUrl(el) {
      const canvas = await html2canvas(el);
      this.dataurl = canvas.toDataURL();
      this.showImage = true;
    }
  }
};
</script>


<style lang="scss" scoped>
.wrapper {
  display: inline-block;
  padding: 0;
  //background-color: white;
  height: 20px;
  width: 100px;
  //   box-shadow: 0 0 4pt rgba(black, 0.5);
}
img.ho-bar-chart {
  height: 20px;
  width: 100px;
}
.bar {
  display: flex;
  flex-direction: row;
  padding: 0;
  align-items: center;
  border-width: 0 0 0 1px;
  border-color: black;
  border-style: solid;
  height: 20px;
  width: 100px;
}

.box {
  display: inline-block;
  border-width: 0 1px 0 0;
  border-color: black;
  border-style: solid;
  width: 10px;
  height: 20px;
}

.v-square {
  -webkit-print-color-adjust: exact;
  background-color: red !important;
  width: 10px;
  height: 10px;
  position: absolute;
}
.v-diamond {
  -webkit-print-color-adjust: exact;
  background-color: blue !important;
  width: 8px;
  height: 8px;
  position: absolute;
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-transform-origin: 0 100%;
  -moz-transform-origin: 0 100%;
  -ms-transform-origin: 0 100%;
  -o-transform-origin: 0 100%;
  transform-origin: 0 100%;
}
.v-circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  position: absolute;
  background-color: #ff6600 !important;
}
</style>